/**
 * Profilo EDIL (Edilcostruzioni).
 *
 * File PRIVATO - gitignorato. Distribuito al team via canale privato.
 *
 * Uso:
 *   ng serve --configuration=edil
 *   ng build --configuration=edil
 */
import { AppEnvironment, sharedEnvironment } from '@env-shared';
import type { CompanyUiConfig } from '../../app/_models/company-ui-config.model';

/**
 * Config UI azienda Edilcostruzioni (cmp_id 16). Esportata a parte cosi' la
 * variante di collaudo (`environment.edil-test.ts`) la riusa senza duplicarla.
 */
export const edilCompanyUiConfig: { [companyId: number]: CompanyUiConfig } = {
	16: {
		// Edilcostruzioni — niente galleria foto
		showGallery: false,
		// Suddivisione cantieri per sezione RFI/EDILCOSTRUZIONI
		worksiteRfiEdil: true,
		// Scadenza idoneità proposta con la periodicità RFI (DOI P SE SU 01.02)
		idoneitaScadenzaRfi: true,
	},
};

export const environment: AppEnvironment = {
	...sharedEnvironment,
	production: true,
	profile: 'edil',

	base_url_browser: 'https://edil.data-smart.it/api',
	base_url: 'https://edil.data-smart.it/api',

	imageBaseURL: 'https://edil.data-smart.it/assets',

	apiGoogleMapsKey: 'AIzaSyAaQ4-aPwqJ1JZojJsRUR5RdqQy0_u5IBE',
	paypal_clientId: 'AS18bscPjfHsLX8NnsYmM0YOw1CEqtS1HQFFIFmllt9RX5g4HpORMhAXS4QDYqv8pQOFZ97GNuuok50G',
	nexi_script: 'https://int-ecommerce.nexi.it/ecomm/XPayBuild/js?alias=ALIAS_WEB_00054558',

	companyUiConfig: edilCompanyUiConfig,

	// Build white-label Edilcostruzioni: niente logo MyTown ne' banner FESR/UE
	showFundingBranding: false,
};
